export default __webpack_public_path__ + "static/media/Reports_subscribe.cdbcc080.svg";